import { enableProdMode, Type } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableUiElements, allControls } from '@trustedshops/tswp-core-ui-elements-ng';
import { Observable } from 'rxjs';
import { environment } from './app/configuration/get-environment.util';
import { carrierWebComponents } from './app/web-components/carrier-web-components';
import { BrowserAppModule } from './browser.module';
import { handleBootstrapError, initializeBootstrapErrorStorage } from './bootstrap-error/bootstrap-error-handler';

import { debugRxJs } from './debug';

// Initialize debug mode if enabled
if (localStorage.getItem('d3bug')) {
  debugRxJs(Observable);
}

// Enable production mode if applicable
if (environment.production) {
  enableProdMode();
}

// Initialize global error storage
initializeBootstrapErrorStorage();

// Bootstrap main application
const platform = platformBrowserDynamic();

platform.bootstrapModule(BrowserAppModule)
  .then(() => {
    // Only bootstrap web components and enable UI elements after main bootstrap succeeds
    // Bootstrap web components
    carrierWebComponents.forEach((webComponentModule: Type<any>) => {
      platform.bootstrapModule(webComponentModule).catch((error) => {
        console.error('[Main] Failed to bootstrap web component', error);
      });
    });

    // Enable UI elements
    enableUiElements({
      platform,
      heliosUri: environment.layout.resources.heliosUri,
      heliosIconFontUri: environment.layout.resources.heliosIconUri,
      controlModules: allControls
    });
  })
  .catch(handleBootstrapError);
